<div class="relative h-full w-full">
  <div class="rounded border border-gray-200 bg-gray-50 px-3 py-3">
    <div class="pb-2 pl-1 text-sm">
      {{ 'vehicleSelection.hint.catalog.text' | transloco }}
    </div>
    <div class="flex gap-2 rounded border border-yellow-300 bg-yellow-100 px-2 py-2 text-xs">
      <i class="pi pi-info-circle pt-[1px] !text-xs text-stone-900"></i>
      <p>
        <span
          [innerHTML]="
            'vehicleSelection.hint.catalog.hint'
              | transloco
                : {
                    bold: '<strong>' + ('vehicleSelection.hint.catalog.bold' | transloco) + '</strong>',
                    bold2: '<strong>' + ('vehicleSelection.hint.catalog.bold2' | transloco) + '</strong>',
                  }
          "></span>
        <button class="ml-1 inline font-bold text-blue-700" (click)="onHintClick.emit()">
          {{ 'vehicleSelection.hint.catalog.link' | transloco }}
        </button>
      </p>
    </div>
  </div>

  <div class="mt-8 flex-1">
    <!-- Makes -->
    <div class="relative">
      <p-autocomplete
        #inputMake
        class="w-full"
        inputStyleClass="w-full py-2 !pr-12"
        [(ngModel)]="selectedMake"
        [suggestions]="filteredMakes()"
        [minQueryLength]="0"
        [delay]="10"
        appendTo="body"
        [completeOnFocus]="false"
        inputId="makeInput"
        (completeMethod)="filterMakes($event)"
        (onSelect)="onSelectMake()"
        (onFocus)="onMakeInputFocussed()"
        (onKeyUp)="onMakeInputKeyUp($event)"
        optionLabel="name"
        placeholder="Marke"
        scrollHeight="220px"
        [showTransitionOptions]="'0ms'"
        [hideTransitionOptions]="'0ms'"
        [overlayOptions]="{ style: { maxWidth: '90dvw' } }">
        <ng-template #empty>
          @if (isLoading()) {
            <div class="px-3 py-3">{{ 'global.loading' | transloco }}</div>
          } @else {
            <div class="px-3 py-3">{{ 'global.empty' | transloco }}</div>
          }
        </ng-template>
        <ng-template let-make #item>
          <div class="w-full whitespace-normal text-sm">
            <p>{{ make.name }}</p>
          </div>
        </ng-template>
      </p-autocomplete>
      <p-button
        *ngIf="inputMake.inputValue()?.length > 1 && !isLoading()"
        icon="pi pi-times"
        class="absolute right-2 top-[6px]"
        [text]="true"
        size="small"
        severity="contrast"
        (click)="clearMake()" />
    </div>

    <!-- Model -->
    <div class="relative mt-4">
      <p-autocomplete
        #inputModel
        class="w-full"
        inputStyleClass="w-full py-2 !pr-12"
        [(ngModel)]="selectedModel"
        [suggestions]="filteredModels()"
        [minQueryLength]="0"
        [delay]="0"
        appendTo="body"
        inputId="modelInput"
        (completeMethod)="filterModels($event)"
        (onSelect)="onSelectModel()"
        (onKeyUp)="onModelInputKeyUp($event)"
        (onFocus)="onModelInputFocussed()"
        optionLabel="name"
        placeholder="Modell"
        [overlayOptions]="{ style: { maxWidth: '90dvw' } }">
        <ng-template #empty>
          @if (isLoading()) {
            <div class="px-3 py-3">{{ 'global.loading' | transloco }}</div>
          } @else {
            <div class="px-3 py-3">{{ 'global.empty' | transloco }}</div>
          }
        </ng-template>
        <ng-template let-modell #item>
          <div class="w-full whitespace-normal text-sm">
            <p>{{ modell.name }}</p>
          </div>
        </ng-template>
      </p-autocomplete>
      <p-button
        *ngIf="inputModel.inputValue()?.length > 1 && !isLoading()"
        icon="pi pi-times"
        class="absolute right-2 top-[6px]"
        [text]="true"
        size="small"
        severity="contrast"
        (click)="clearModel()" />
    </div>

    <!-- Vehicles -->
    <div class="relative mt-4">
      <p-autocomplete
        #inputVehicle
        class="w-full"
        inputStyleClass="w-full py-2 !pr-12"
        [(ngModel)]="selectedVehicle"
        [suggestions]="filteredVehicles()"
        [minQueryLength]="0"
        [delay]="0"
        appendTo="body"
        inputId="vehicleInput"
        (completeMethod)="filterVehicles($event)"
        (onSelect)="onSelectVehicle()"
        (onKeyUp)="onVehicleInputKeyUp($event)"
        (onFocus)="onVehicleInputFocussed()"
        optionLabel="displayString"
        placeholder="Motortyp"
        [overlayOptions]="{ style: { maxWidth: '90dvw' } }">
        <ng-template #empty>
          @if (isLoading()) {
            <div class="px-3 py-3">{{ 'global.loading' | transloco }}</div>
          } @else {
            <div class="px-3 py-3">{{ 'global.empty' | transloco }}</div>
          }
        </ng-template>
        <ng-template let-vehicle #item>
          <div class="w-full whitespace-normal text-sm">
            <p>{{ vehicle.displayString }}</p>
          </div>
        </ng-template>
      </p-autocomplete>

      <p-button
        *ngIf="inputVehicle.inputValue()?.length > 2 && !isLoading()"
        icon="pi pi-times"
        class="absolute right-2 top-[6px]"
        [text]="true"
        size="small"
        severity="contrast"
        (click)="clearVehicle()" />
    </div>

    <div class="mb-4 mt-12 flex w-full justify-end">
      <p>
        @if (isLoading()) {
          {{ 'global.loading' | transloco }}
        }
      </p>
      <p-button
        #submitButtonCatalog
        severity="contrast"
        [label]="'vehicleSelection.mainBtnText' | transloco"
        size="large"
        (click)="onFinishSelection()"
        [disabled]="!selectedVehicle()"
        class="px-1"></p-button>
    </div>
  </div>
</div>
